var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { TraitRegistryActortype } from './actor/TraitRegistryActortype';
import { TraitRegistryAspect } from './aspect/TraitRegistryAspect';
import { TraitRegistryCss } from './css/TraitRegistryCss';
import { TraitRegistrySystem } from './system/TraitRegistrySystem';
import { TraitRegistryAnimation } from './animation/TraitRegistryAnimation';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { TraitRegistryDesign } from './design/TraitRegistryDesign';
import { TraitRegistryPrimitives } from './primitives/TraitRegistryPrimitives';
import { TraitRegistryQuestionType } from './questionType/TraitRegistryQuestionType';
import { TraitRegistryMedia } from './media/TraitRegistryMedia';
import { TraitRegistryEvent } from './event/TraitRegistryEvent';
import { RegistryRoof } from '../RegistryRoof';
import { mappedTransitionTransformProperties } from './css/TraitRegistryCssTransition';
import { TraitRegistryActor } from './actor/TraitRegistryActor';
export class TraitRegistry extends RegistryRoof {
    registryType = 'trait';
    c_actor = new TraitRegistryActor(this);
    c_actortype = new TraitRegistryActortype(this);
    c_aspect = new TraitRegistryAspect(this);
    c_animation = new TraitRegistryAnimation(this);
    c_design = new TraitRegistryDesign(this);
    c_css = new TraitRegistryCss(this);
    c_media = new TraitRegistryMedia(this);
    c_system = new TraitRegistrySystem(this);
    c_qt = new TraitRegistryQuestionType(this);
    c_event = new TraitRegistryEvent(this);
    c_primitive = new TraitRegistryPrimitives(this);
    // readonly c_signals = new SignalRegistry(this);
    get registry_object() {
        return super.registry_object;
    }
    reverseUnifier = {
        animate: [
            'animateAttention',
            'animateAppear',
            // 'animateEntrance',
            'animateDisappear',
            'animateTextAppear',
            'animateTextDisappear',
            'animateTextEffect',
            'animateBoxShadow',
            'animateTransform',
            'animateBackground',
        ],
        content: ['image', 'text', 'box', 'table', 'gap', 'video', 'audio', 'sound', 'childFromSkeleton', 'childFromAspectName'], // 'childFromTraverse',
    };
}
__decorate([
    memoize
], TraitRegistry.prototype, "registry_object", null);
export function transitionProp(key) {
    if (mappedTransitionTransformProperties.includes(key)) {
        return 'transform';
    }
    return key;
}
